import React, { useEffect } from "react";
import { Box, Typography, Container, Divider } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { Terms_and_ConditionRead } from "../../Redux/Slices/PrivacyPolicy/TeramsandConditionRead";
import "../PrivacyPolicy/PrivacyPolicy.css";

const TermsandConditions: React.FC = () => {
  const dispatch = useAppDispatch();
  const listPrivacyPolicy = useAppSelector(
    (state) => state.listTermsandCondition?.data
  );

  console.log(listPrivacyPolicy, "list");

  useEffect(() => {
    dispatch(Terms_and_ConditionRead());
  }, [dispatch]);

  return (
    <Box className="privacy-policy-wrapper">
      <Container className="privacy-policy-container">
        {/* Header */}
        <Box className="privacy-policy-header">
          <Typography variant="h3" fontWeight="bold" gutterBottom>
            {listPrivacyPolicy?.data.template_name}
          </Typography>
          <Typography variant="h6" className="privacy-policy-date">
            Last updated:{" "}
            {new Date().toLocaleDateString("en-GB", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            })}
          </Typography>
        </Box>

        <Divider sx={{ mb: 4 }} />

        {/* Render HTML from API */}
        <Box className="privacy-policy-content-wrapper">
          <Box
            className="privacy-policy-content"
            sx={{
              fontSize: "16px",
              lineHeight: 1.7,
              color: "text.primary",
              "& h2": { fontSize: "22px", fontWeight: "bold", mt: 3, mb: 2 },
              "& h3": { fontSize: "18px", fontWeight: "600", mt: 2, mb: 1 },
              "& p": { mb: 2 },
              "& ul": { pl: 3, mb: 2 },
              "& li": { mb: 1 },
            }}
            dangerouslySetInnerHTML={{
              __html: listPrivacyPolicy?.data.template_content || "",
            }}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default TermsandConditions;
